var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91669 16.6666C2.58335 16.6666 2.29169 16.5416 2.04169 16.2916C1.79169 16.0416 1.66669 15.75 1.66669 15.4166V4.58331C1.66669 4.24998 1.79169 3.95831 2.04169 3.70831C2.29169 3.45831 2.58335 3.33331 2.91669 3.33331H17.0834C17.4167 3.33331 17.7084 3.45831 17.9584 3.70831C18.2084 3.95831 18.3334 4.24998 18.3334 4.58331V15.4166C18.3334 15.75 18.2084 16.0416 17.9584 16.2916C17.7084 16.5416 17.4167 16.6666 17.0834 16.6666H2.91669ZM10 10.375L2.91669 5.72915V15.4166H17.0834V5.72915L10 10.375ZM10 9.12498L17 4.58331H3.02085L10 9.12498ZM2.91669 5.72915V4.58331V15.4166V5.72915Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.1155091c304c0ec364d38dd4c1dd74ce.svg";
export { ForwardRef as ReactComponent };